import {
  attachRelationships,
  createPlatformState,
  createPlatformGetters,
  platformAction,
  platformMutations
} from '@sohohouse/common-frontend/utils'
import getRequest from './get-request'
import defaultMutations from './default-mutations'
import defaultState, { request as defaultRequestState } from './default-state'
import fetchAction from './fetch-action'
import hashRequest, { DEFAULT_HASH } from './hash-request'

const option = {
  relationshipMap: {
    venues: 'venues/resourceById',
    events: 'events/events/resourceById',
    event_categories: 'events/categories/resourceById',
    categories: 'content/categories/resourceById'
  }
}

const platformGetters = createPlatformGetters(option)

export {
  attachRelationships,
  createPlatformState,
  platformAction,
  platformGetters,
  platformMutations,
  getRequest,
  defaultMutations,
  defaultState,
  defaultRequestState,
  fetchAction,
  hashRequest,
  DEFAULT_HASH
}
